// extracted by mini-css-extract-plugin
export default {"h1":"product_carry_modal__h1--cQMr","h2":"product_carry_modal__h2--BUD+","product":"product_carry_modal__product--ij6k","img":"product_carry_modal__img--oMqI"};